import { useEffect, useState } from "react";
import Header from "@/components/Header";
import DepositForm, { DepositHistory } from "@/components/DepositForm";
import { api } from "@/lib/api";

const UPI_ID = "SBIBHIM.INSTANT90885723158455195@sbipay";
const MERCHANT = "Ishika smart offer Private Limited";
const QR_SRC = `https://api.qrserver.com/v1/create-qr-code/?size=340x340&margin=6&data=${encodeURIComponent(
  `upi://pay?pa=${UPI_ID}&pn=${encodeURIComponent(MERCHANT)}&cu=INR`
)}`;

export default function FundDepositQR() {
  const [reloadKey, setReloadKey] = useState(0);
  const [bank, setBank] = useState(null);

  useEffect(() => {
    api.get("/deposits/bank-info").then((r) => setBank(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-slate-100">
      <Header />
      <div style={{ background: "linear-gradient(180deg, #7f1d1d 0%, #991b1b 100%)" }}>
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 text-center text-white">
          <h1 className="text-3xl font-extrabold tracking-tight" style={{ fontFamily: "Outfit, sans-serif" }}>
            Fund Deposit
          </h1>
          <p className="text-white/85 mt-1">Pay via QR Code</p>
        </div>
      </div>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 -mt-6 pb-14 space-y-5">
        {/* Account selector */}
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5">
          <label className="block text-sm font-semibold text-slate-700 mb-2">Account</label>
          <div
            data-testid="account-select"
            className="w-full border-2 border-blue-900 rounded-lg px-4 py-3 bg-white text-slate-900 font-medium"
          >
            {bank?.bank_name || "State Bank of INDIA"}
          </div>
        </div>

        {/* QR card */}
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5 flex flex-col items-center">
          <div className="text-blue-900 font-black tracking-widest text-xl mb-3" style={{ fontFamily: "Outfit, sans-serif" }}>
            SCAN &amp; PAY
          </div>
          <div className="rounded-xl border border-slate-200 p-2 bg-white shadow-sm">
            <img
              data-testid="deposit-qr-image"
              src={QR_SRC}
              alt="UPI QR Code"
              className="h-64 w-64 object-contain"
            />
          </div>
          <div className="mt-4 text-center">
            <div className="text-sm text-slate-700">
              <span className="font-semibold">UPI ID:</span>{" "}
              <span className="font-mono text-blue-900 break-all">{bank?.upi_id || UPI_ID}</span>
            </div>
            <div className="text-sm text-slate-700 mt-1">
              <span className="font-semibold">Merchant Name:</span>{" "}
              <span className="text-red-700 font-semibold">{bank?.merchant_name || MERCHANT}</span>
            </div>
          </div>
        </div>

        <DepositForm method="qr" onSubmitted={() => setReloadKey((k) => k + 1)} />
        <DepositHistory reloadKey={reloadKey} />
      </main>
    </div>
  );
}
